<template>
    <v-dialog
        :value="value"
        @input="$emit('input', $event)"
        max-width="630"
    >
        <template v-slot:activator="{ on }">
            <slot name="activator" :on="on"></slot>
        </template>

        <v-card class="pt-3">
            <v-card-text v-if="date && time">
                <div class="d-flex flex-column flex-sm-row">
                    <v-date-picker
                        v-model="date"
                        first-day-of-week="1"
                        :no-title="false"
                        locale="sk"
                        scrollable
                    ></v-date-picker>

                    <v-time-picker
                        v-model="time"
                        format="24hr"
                        :no-title="false"
                        scrollable
                    ></v-time-picker>
                </div>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="chooseAndClose">Zvoliť</v-btn>
                <v-btn text color="secondary" @click="$emit('input', false)">Zrušiť</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
  props: {
    value: {
      type: Boolean,
      required: true
    },
    dateTime: {
      type: String,
      required: true,
      default: ''
    }
  },

  data () {
    return {
      dateTimeInternal: null,
      date: '',
      time: ''
    }
  },

  watch: {
    dateTime: {
      immediate: true,
      handler () {
        this.parseDateTime()
      }
    },
    value (isOpen) {
      if (isOpen) {
        if (!this.dateTimeInternal) {
          this.parseDateTime()
        }
      } else {
        this.dateTimeInternal = null
        this.date = ''
        this.time = ''
      }
    }
  },

  methods: {
    parseDateTime () {
      this.dateTimeInternal = this.dateTime.length
        ? this.$dateFns.parseISO(this.dateTime)
        : new Date()
      this.date = this.$dateFns.formatDVuetify(this.dateTimeInternal)
      this.time = this.$dateFns.formatTVuetify(this.dateTimeInternal)
    },
    updateDateTime () {
      this.$emit('update:dateTime', this.$dateFns.formatDTServer(this.dateTimeInternal))
    },
    chooseAndClose () {
      this.dateTimeInternal = this.$dateFns.parseDTVuetify(this.date, this.time)
      this.updateDateTime()
      this.$emit('input', false)
    }
  }
})
</script>
